import { useSearchParams, useNavigate } from 'react-router-dom';

import styles from './access-denied.module.scss';

interface AccessDeniedProps {
  logoutPath: string;
}

export const AccessDenied = ({ logoutPath }: AccessDeniedProps) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const errorDescription = searchParams.get('error_description');

  const handleTryDifferentAccount = () => {
    navigate(logoutPath);
  };

  return (
    <div className={styles.accessDenied}>
      <h1>Access Denied</h1>
      <p>{errorDescription || 'You are not authorized to access this application.'}</p>
      <p>Please contact your administrator if you believe this is a mistake.</p>
      <button className={styles.button} onClick={handleTryDifferentAccount}>
        Try Different Account
      </button>
    </div>
  );
};
